var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useState } from 'react';
import { TextField } from '@material-ui/core';
export const EntityTextField = (_a) => {
    var _b, _c;
    var { select, plugin, column, label, placeholder, helperText, error, children, onChange } = _a, props = __rest(_a, ["select", "plugin", "column", "label", "placeholder", "helperText", "error", "children", "onChange"]);
    const timeoutRef = useRef();
    const [value, setValue] = useState(props.value || '');
    // useEffect(() => {
    //   if (props.value) setValue(props.value);
    // }, [props.value]);
    const validationError = (_c = (_b = plugin.edit) === null || _b === void 0 ? void 0 : _b.validateError) === null || _c === void 0 ? void 0 : _c.call(_b, column, value);
    return (React.createElement(TextField, { className: 'entity-field', select: select, fullWidth: true, 
        // disabled={disabled}
        value: value || '', size: 'small', variant: 'outlined', label: label, placeholder: placeholder || 'Input text', error: Boolean(error) || Boolean(validationError), helperText: validationError || helperText, onChange: event => {
            setValue(event.target.value);
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
                onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value);
            }, 300);
        } }, children));
};
//# sourceMappingURL=EntityTextField.js.map